var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon32PxMegaphoneOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 10.5v8.59l2 2V7.021a1 1 0 10-2 0v.637a9.034 9.034 0 01-7.009 3.343h-1.078l1.963 1.963A11.023 11.023 0 0024 10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.758 23.675l.008.009a1 1 0 01-1.414 1.414l-5.971-5.971a8.868 8.868 0 00-.747-.087l-2.724 6.356a.999.999 0 01-.919.606h-4a1 1 0 01-.919-1.393l2.403-5.607h-.484a3.003 3.003 0 01-3-3v-2a3.004 3.004 0 012.339-2.926L8.795 9.54a1 1 0 011.414-1.414l15.549 15.548zM13.99 14.737v2.265h2.265l-2.265-2.264zm-3 2.265a1 1 0 01-1-1v-2a1 1 0 011-1h1v4h-1zm2.341 7h-1.824l2.142-5h1.825l-2.143 5z",
    clipRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon32PxMegaphoneOff);
export default __webpack_public_path__ + "static/media/4-icon-32-px-megaphone-off.b5e10f73.svg";
export { ForwardRef as ReactComponent };